import React from 'react';
import CareerPage from './Vacancy';
const ContactUs = () => {
  return (
   
<div className='page-template page-template-elementor_header_footer page page-id-1458 jkit-color-scheme elementor-default elementor-template-full-width elementor-kit-3 elementor-page elementor-page-1458'>
<div id="page" class="jkit-template  site">
    <div data-elementor-type="wp-page" data-elementor-id="1458" class="elementor elementor-1458">
    <div class="elementor-element elementor-element-0ad9abe e-flex e-con-boxed e-con e-parent" data-id="0ad9abe" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
<div class="e-con-inner">
<div class="elementor-element elementor-element-77a7fed e-con-full e-flex e-con e-child" data-id="77a7fed" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
<div class="elementor-element elementor-element-74dcfa1 elementor-widget__width-inherit elementor-invisible elementor-widget elementor-widget-heading" data-id="74dcfa1" data-element_type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="heading.default">
<div class="elementor-widget-container">
{/* <h5 class="elementor-heading-title elementor-size-default">Contact Us</h5>    */}
   </div>
</div>
<div class="elementor-element elementor-element-2b47805 elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_animated_text" data-id="2b47805" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:200,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="jkit_animated_text.default">
<div class="elementor-widget-container">
<div  class="jeg-elementor-kit jkit-animated-text jeg_module_1458_2_676b7a305aa37"  data-style="highlighted" data-text="Touch " data-shape="underline"><h1 class="animated-text"><span class="normal-text style-color">Join Our </span><span class="dynamic-wrapper style-color"><span class="dynamic-text">Team </span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none"><path class="style-color"  d="M3,77.5s200.54-11,493,0" transform="translate(-2.75 -68.11)"/></svg></span><span class="normal-text style-color"></span></h1></div>     </div>
</div>
<div class="elementor-element elementor-element-4ce1502 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor" data-id="4ce1502" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:300,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="text-editor.default">
<div class="elementor-widget-container">
            <p>We are always looking for passionate professionals to join our journey of innovation.</p>                      </div>
</div>
</div>
</div>
</div>
<div class="elementor-element elementor-element-56c7cef e-flex e-con-boxed e-con e-parent" data-id="56c7cef" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
<div class="e-con-inner">
<div class="elementor-element elementor-element-ae21074 e-con-full e-flex e-con e-child" data-id="ae21074" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;content_width&quot;:&quot;full&quot;}">
<div class="elementor-element elementor-element-9b35ab3 e-flex e-con-boxed e-con e-child" data-id="9b35ab3" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}">
<div class="e-con-inner">
<div class="elementor-element elementor-element-b9dd964 elementor-widget__width-inherit elementor-widget elementor-widget-jkit_heading" data-id="b9dd964" data-element_type="widget" data-widget_type="jkit_heading.default">
<div class="elementor-widget-container">
<div  class="jeg-elementor-kit jkit-heading  align-left align-tablet- align-mobile- jeg_module_1458_3_676b7a305fa29" ><div class="heading-section-title  display-inline-block"><h3 class="heading-title"><span class="style-color"><span>Build the Future with Us — One Innovation at a Time.</span></span></h3></div></div>      </div>
</div>
<div class="elementor-element elementor-element-5a5ec36 elementor-widget__width-inherit elementor-widget elementor-widget-text-editor" data-id="5a5ec36" data-element_type="widget" data-widget_type="text-editor.default">
<div class="elementor-widget-container">
At HHG, we're not just offering jobs — we're shaping careers. We believe in empowering talent, encouraging innovation, and creating an environment where every idea counts. Whether you're an experienced professional or just starting out, join us on our journey to engineer a smarter, more automated tomorrow.                   </div>
</div>
<div class="elementor-element elementor-element-4f6a1c4 elementor-widget elementor-widget-metform" data-id="4f6a1c4" data-element_type="widget" data-widget_type="metform.default">
<div class="elementor-widget-container">
<div id="mf-response-props-id-1492" data-previous-steps-style="" data-editswitchopen="" data-response_type="alert" data-erroricon="fas fa-exclamation-triangle" data-successicon="fas fa-check" data-messageposition="top" class="   mf-scroll-top-no">
<div class="formpicker_warper formpicker_warper_editable" data-metform-formpicker-key="1492" >
 
<div class="elementor-widget-container">


{/* <div
id="metform-wrap-4f6a1c4-1492"
class="mf-form-wrapper"
data-form-id="1492"
data-action="https://templatekit.jegtheme.com/robix/wp-json/metform/v1/entries/insert/1492"
data-wp-nonce="52dd570f15"
data-form-nonce="f0d393b978"
data-quiz-summery = "false"
data-save-progress = "false"
data-form-type="general-form"
data-stop-vertical-effect=""
></div> */}
               

</div>


        </div>
        </div>      </div>
                </div>
                    </div>
                </div>
                
                <div
      className="elementor-element elementor-element-76cf223 e-con-full e-flex e-con e-child"
      data-id="76cf223"
      data-element-type="container"
      data-settings='{"content_width":"full","background_background":"classic"}'
    >
      {/* Intro Message */}
      <div
        className="elementor-element elementor-element-94eb9aa elementor-widget__width-inherit elementor-widget elementor-widget-text-editor"
        data-id="94eb9aa"
        data-element-type="widget"
        data-widget-type="text-editor.default"
      >
        <div className="elementor-widget-container">
          {/* <p>
            "We’re here to guide you through every step of your career journey. Feel free to connect with us — your future starts with a conversation."
          </p> */}
        </div>
      </div>

      {/* Contact Container */}
      <div
        className="elementor-element elementor-element-982329d e-con-full e-flex e-con e-child"
        data-id="982329d"
        data-element-type="container"
        data-settings='{"content_width":"full"}'
      >
        <div
          className="elementor-element elementor-element-e211a13 e-con-full e-flex e-con e-child"
          data-id="e211a13"
          data-element-type="container"
          data-settings='{"content_width":"full"}'
        >
          {/* HR Label */}
          <div
            className="elementor-element elementor-element-2745fe7 elementor-widget__width-inherit elementor-widget elementor-widget-text-editor"
            data-id="2745fe7"
            data-element-type="widget"
            data-widget-type="text-editor.default"
          >
            <div className="elementor-widget-container">
              {/* <p>HR Department</p> */}
            </div>
          </div>

          {/* HR Contact Info */}
          <div
            className="elementor-element elementor-element-hr-contact elementor-widget__width-inherit elementor-widget elementor-widget-text-editor"
            data-id="hrcontact"
            data-element-type="widget"
            data-widget-type="text-editor.default"
          >
            <div className="elementor-widget-container" style={{color:'white', paddingBottom:'10px'}}>
              <p>
                <strong>Emails:</strong><br />
                hhghr@zventures.in<br />
               <br />
                <strong>Phone Number:</strong><br />
                +91 70699 90856<br />
              </p>
            </div>
          </div>

          {/* Approach Message */}
          <div
            className="elementor-element elementor-element-contact-approach elementor-widget__width-inherit elementor-widget elementor-widget-text-editor"
            data-id="contactapproach"
            data-element-type="widget"
            data-widget-type="text-editor.default"
          >
            <div className="elementor-widget-container" style={{color:'white'}}>
              <p>
                Interested in joining our team? Send us your resume via email or connect over a call.
                We look forward to exploring opportunities with you!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
                </div>
                    </div>
                </div>

        <CareerPage/>
        {/* <div class="elementor-element elementor-element-7c35171 e-flex e-con-boxed e-con e-parent" data-id="7c35171" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
                    <div class="e-con-inner">
                  
                    <div class="elementor-element elementor-element-815d876 e-con-full e-flex e-con e-child" data-id="815d876" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
                <div class="elementor-element elementor-element-6e3651b jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="6e3651b" data-element_type="widget" data-widget_type="jkit_icon_box.default">
                <div class="elementor-widget-container">
            <div  class="jeg-elementor-kit jkit-icon-box icon-position-top elementor-animation- jeg_module_1458_6_676b7a3078a7d" ><div class="jkit-icon-box-wrapper hover-from-left"><div class="icon-box icon-box-header elementor-animation-float"><div class="icon style-color"><i aria-hidden="true" class="jki jki-phone-handset-light"></i></div></div><div class="icon-box icon-box-body">
                <h6 class="title">Contact for Queries</h6><p class="icon-box-description">+91 70699 92052

</p>
            </div>
           
            </div></div>        </div>
                </div>
                </div>
      
                <div class="elementor-element elementor-element-815d876 e-con-full e-flex e-con e-child" data-id="815d876" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
                <div class="elementor-element elementor-element-6e3651b jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="6e3651b" data-element_type="widget" data-widget_type="jkit_icon_box.default">
                <div class="elementor-widget-container">
            <div  class="jeg-elementor-kit jkit-icon-box icon-position-top elementor-animation- jeg_module_1458_6_676b7a3078a7d" ><div class="jkit-icon-box-wrapper hover-from-left"><div class="icon-box icon-box-header elementor-animation-float"><div class="icon style-color"><i aria-hidden="true" class="jki jki-phone-handset-light"></i></div></div><div class="icon-box icon-box-body">
                <h6 class="title">Contact for Career</h6><p class="icon-box-description">+91 70699 90856



</p>
            </div>
           
            </div></div>        </div>
                </div>
                </div>
                <div class="elementor-element elementor-element-0011d1f e-con-full e-flex e-con e-child" data-id="0011d1f" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
                <div class="elementor-element elementor-element-33eb82a jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="33eb82a" data-element_type="widget" data-widget_type="jkit_icon_box.default">
                <div class="elementor-widget-container">
            <div  class="jeg-elementor-kit jkit-icon-box icon-position-top elementor-animation- jeg_module_1458_5_676b7a30773e2" ><div class="jkit-icon-box-wrapper hover-from-left"><div class="icon-box icon-box-header elementor-animation-float"><div class="icon style-color"><i aria-hidden="true" class="jki jki-envelope1-light"></i></div></div><div class="icon-box icon-box-body">
                <h6 class="title">Email</h6><p class="icon-box-description">inquiry@hhgindia.com</p>
            </div>
           
            </div></div>        </div>
                </div>
                </div>
                <div class="elementor-element elementor-element-9c7e9aa e-con-full e-flex e-con e-child" data-id="9c7e9aa" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
                <div class="elementor-element elementor-element-62847d0 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="62847d0" data-element_type="widget" data-widget_type="jkit_icon_box.default">
                <div class="elementor-widget-container">
            <div  class="jeg-elementor-kit jkit-icon-box icon-position-top elementor-animation- jeg_module_1458_4_676b7a3075c32" ><div class="jkit-icon-box-wrapper hover-from-left"><div class="icon-box icon-box-header elementor-animation-float"><div class="icon style-color"><i aria-hidden="true" class="jki jki-map-marker1-light"></i></div></div><div class="icon-box icon-box-body">
                <h6 class="title">Our Location</h6><p class="icon-box-description">221 Navi Jamvai
                Ajwa Nimeta Road, Vadodara,Gujarat,India-390019</p>
            </div>
           
            </div></div>        </div>
                </div>
                </div>
             
             
            
                    </div>
                </div> */}
               

{/* <div className="map-container">
<iframe
title="Google Map"
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4377.477998751421!2d73.3100604!3d22.340647900000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fd1005658addd%3A0x7913784e3fa41e80!2sHHG%20INDUSTRIES%20PVT%20LTD!5e1!3m2!1sen!2sin!4v1743757203380!5m2!1sen!2sin"
width="100%" // Make it responsive
height="450"
style={{ border: 0 }} 
allowFullScreen
loading="lazy"
referrerPolicy="no-referrer-when-downgrade"
/>
</div> */}
                            </div>
                            </div>
                            </div>
  );
};
 
export default ContactUs;